import browserLocale from 'browser-locale';
import { getCurrentTimezone } from 'src/react/_util/dates/timezone';
import { UAParser } from 'ua-parser-js';
import { getAuth } from './AuthModule';

export const getYemboAxiosDefaultHeaders = () => {
  const { device, browser, os } = UAParser();

  const locale = browserLocale();

  const { accessToken, impersonatedCompanyKeys, impersonatedRole } = getAuth();

  return {
    'X-Employee-Access-Token': accessToken,
    'X-Company-Keys': impersonatedCompanyKeys,
    'X-Role': impersonatedRole,

    'X-Yembo-Locale': locale,
    'X-Yembo-Timezone': getCurrentTimezone(),
    'X-Yembo-Hardware-Model': device.model || '',
    'X-Yembo-Hardware-Manufacturer': device.vendor || '',

    'X-Yembo-Browser': browser.name || '',
    'X-Yembo-Browser-Version': browser.version || '',

    'X-Yembo-OS': os.name || '',
    'X-Yembo-OS-Version': os.version || '',

    'X-Yembo-Screen-Width': window.screen.width.toString(),
    'X-Yembo-Screen-Height': window.screen.height.toString(),
    'X-Yembo-Screen-Density': window.devicePixelRatio.toString(),
    'X-Yembo-Memory': navigator.deviceMemory || '',
  };
};
